/* eslint-disable prettier/prettier */
import React from 'react';
import * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';
import styles from '../../ProductTile.module.scss';
import { Attributes } from './Attributes';

interface IProductAttributeSelector {
  selectableVariantAttributes: Types.SelectableVariantAttribute[];
  onAttributeChange: AppCallbackFn;
  attributes: Types.VariantAttributes[];
}

export const ProductAttributeSelector = ({ selectableVariantAttributes, onAttributeChange, attributes }: IProductAttributeSelector) => {
  return (
    <div className={styles.productAttributeSelector}>
        {selectableVariantAttributes.map((attribute) => {
          return (
            <Attributes onAttributeChange={onAttributeChange} attribute={attribute} attributes={attributes} key={attribute.type} />
          );
        })}
    </div>
  );
};
